"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cDefaultUtcDateTimeLuxonFormat = exports.luxonDateFormatPerGroup = exports.cMonthsIndexMap = exports.cDaysIndexMap = exports.BaseDateUnits = exports.cDateUnitAdvanced = exports.cDateUnitPlural = exports.cDateUnit = void 0;
exports.cDateUnit = {
    day: 'day',
    week: 'week',
    month: 'month',
    quarter: 'quarter',
    year: 'year'
};
exports.cDateUnitPlural = {
    days: 'days',
    weeks: 'weeks',
    months: 'months',
    years: 'years'
};
exports.cDateUnitAdvanced = {
    timeOfDay: 'timeOfDay',
    dayOfWeek: 'dayOfWeek',
    monthOfYear: 'monthOfYear'
};
exports.BaseDateUnits = [
    exports.cDateUnit.day,
    exports.cDateUnit.week,
    exports.cDateUnit.month,
    exports.cDateUnit.year
];
exports.cDaysIndexMap = {
    monday: 1,
    tuesday: 2,
    wednesday: 3,
    thursday: 4,
    friday: 5,
    saturday: 6,
    sunday: 7
};
exports.cMonthsIndexMap = {
    january: 1,
    february: 2,
    march: 3,
    april: 4,
    may: 5,
    june: 6,
    july: 7,
    august: 8,
    september: 9,
    october: 10,
    november: 11,
    december: 12
};
exports.luxonDateFormatPerGroup = {
    day: 'yyyy-MM-dd',
    week: 'yyyy-\'w\'WW', // prints as 2023-w23, or 23rd week of 2023
    month: 'yyyy-MM',
    year: 'yyyy',
    timeOfDay: 'HH:00',
    dayOfWeek: 'cccc',
    monthOfYear: 'LLLL'
};
exports.cDefaultUtcDateTimeLuxonFormat = "yyyy-MM-dd HH:mm:ss";
